import { render, staticRenderFns } from "./ExternalLink.vue?vue&type=template&id=2dcd0c2a"
import script from "./ExternalLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalLink.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports